import timeslotsAPI from "../../API/endpoints/timeslots";
import { sliceActions } from "../timeslots-slice";

export const fetch = (query) => {
  return async (dispatch) => {
    try {
      const response = await timeslotsAPI.get(query);
      dispatch(sliceActions.populateData(response.data.availables));
    } catch (error) {
      console.log(error);
    }
  };
};
